<div class="mainBody">
  <app-header [userDetails]="userDetails"></app-header>

  @if (loading$ | async) {
    <div class="nav-loader-overlay">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    </div>
  }

  <div class="flexBody d-flex">
    <div class="internalBodyOne">
      <app-sidebar [userDetails]="userDetails"></app-sidebar>
    </div>
    <div class="internalBodyTwo">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
